// src/components/Header.js
import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { AuthContext } from '../AuthContext';
import '../styles/Header.scss';

// Import icons (example: using react-icons)
// You might need to install react-icons: npm install react-icons
import { FaUserCircle, FaSignOutAlt, FaPlus, FaListAlt, FaComments, FaCog, FaAngleDown, FaAngleUp } from 'react-icons/fa'; // Added dropdown arrows

function Header({ onNewEssay }) { // Accept onNewEssay as a prop
  // Get userData from context, not username directly
  const { userData, clearToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // Check username within userData
  const username = userData?.username;
  const isAdmin = username === "charles" || username === "cillian";

  const handleLogout = () => {
    setIsDropdownOpen(false); // Close dropdown on logout
    clearToken(true);
    navigate('/');
  };

  const handleNewEssayClick = () => {
    if (typeof onNewEssay === 'function') {
      onNewEssay(); // Call the function passed from App.js
    } else {
      console.warn("onNewEssay prop is not a function or not provided to Header");
      // Fallback or alternative logic if needed
    }
    setIsDropdownOpen(false); // Close dropdown after clicking
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Close dropdown if clicking outside
  // This requires a bit more setup, maybe add later if needed

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          {/* Change logo link to a button that creates a new essay */}
          <button onClick={handleNewEssayClick} className="header-logo-link">
            <Logo className="header-logo" />
          </button>
        </div>

        <div className="header-right">
          {/* Use userData?.username to check login status */}
          {userData?.username ? (
            <>
              {/* Action Icons/Links - Keep essential actions visible */}
              <button onClick={handleNewEssayClick} className="header-icon-button" title="New Essay">
                <FaPlus />
                <span className="icon-label mobile-visible">New Essay</span>
              </button>
              <Link to="/dashboard" className="header-icon-button" title="My Essays">
                <FaListAlt />
                <span className="icon-label mobile-visible">My Essays</span>
              </Link>
              <Link to="/feedback" className="header-icon-button hide-on-mobile" title="Feedback">
                <FaComments />
                <span className="icon-label">Give Feedback</span>
              </Link>

              {/* User Menu Dropdown */}
              <div className="user-menu">
                <button onClick={toggleDropdown} className="header-icon-button user-avatar-button" title="Account Menu">
                  <div className="user-avatar">
                    {/* Display user initial from userData?.username */}
                    {userData?.username ? userData.username.charAt(0).toUpperCase() : ' '}
                  </div>
                  {/* <span className="username-short">{username}</span> */}
                  {isDropdownOpen ? <FaAngleUp /> : <FaAngleDown />}
                </button>

                {isDropdownOpen && (
                  <div className="user-dropdown-content">
                    {/* Display username from userData?.username */}
                    <div className="dropdown-username">Hi, {userData?.username}!</div>
                    
                    {/* Redundant menu options that mirror the header icons */}
                    <button onClick={handleNewEssayClick} className="dropdown-button">
                      <FaPlus /> New Essay
                    </button>
                    <Link to="/dashboard" onClick={() => setIsDropdownOpen(false)}>
                      <FaListAlt /> My Essays
                    </Link>
                    <Link to="/feedback" onClick={() => setIsDropdownOpen(false)}>
                      <FaComments /> Give Feedback
                    </Link>
                    
                    <div className="dropdown-divider"></div>
                    
                    <Link to="/account" onClick={() => setIsDropdownOpen(false)}>My Account</Link>
                    {isAdmin && <Link to="/admin/feedback" onClick={() => setIsDropdownOpen(false)}>View Feedback</Link>}
                    {isAdmin && <Link to="/admin/essays" onClick={() => setIsDropdownOpen(false)}>View Essays</Link>}
                    <Link to="/faq" onClick={() => setIsDropdownOpen(false)}>FAQ</Link>
                    <button onClick={handleLogout} className="logout-button-dropdown">
                      <FaSignOutAlt /> Logout
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <> {/* Fallback for logged-out users */}
              <Link to="/login" className="header-link">Login</Link>
              <Link to="/register" className="header-link primary">Sign Up</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;